<template>
  <div class="flex-div">
    <div class="flex-nav">
      <span class="nav-txt" v-for="item in tabsData" :key="item.tabNo"
            :class="{ cur: titleActive === item.tabNo }"
            @click="onClickTab(item.tabNo)"
      >
            {{ item && item.tabName }}
        </span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'select-course-tabs',
  props: {
    tabsData: {
      type: Array,
      default: () => {
        return []
      }
    },
    titleActive: {
      type: String,
      default: '1'
    }
  },
  methods: {
    onClickTab(tabNo) {
      this.$emit('onClickTab', tabNo)
    }
  }
}
</script>

<style lang="less" scoped>
.flex-div {
  background: #F9F8F7;
  height: 42px;
  width: 100%;

  .flex-nav {
    display: flex;
    align-items: center;

    .nav-txt {
      display: block;
      text-align: center;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-size: 14px;
      color: #333333;
      flex: 1;
      cursor: pointer; // 设置鼠标悬停时显示为可点击状态

      &.cur {
        font-weight: 600;
        color: #eb1700;
        position: relative;
        height: 42px;
        line-height: 42px;

        &::after {
          position: absolute;
          bottom: 4px;
          left: 50%;
          transform: translateX(-50%);
          content: '';
          width: 23px;
          height: 9px;
          background-image: url('../../../assets/images/cartojourney/img18.png');
          background-repeat: no-repeat;
          background-size: 100%;
        }
      }
    }
  }
}

.tabs-wrapper {
  height: 45px;
  border-bottom: 1px #eeeeee solid;
}
</style>



// WEBPACK FOOTER //
// src/views/cartoJourney/components/SelectCourseTabs.vue